import React, { useContext, useEffect, useState } from 'react'
import SlotsTab from './SlotsTab'
import GlobalContext from '../GlobalContext'
import { Spin } from 'antd'

export default function SlotsPage () {
  const { slots, getSlots } = useContext(GlobalContext)
  const [_, setTime] = useState(Date.now())

  useEffect(() => {
    getSlots()
    const interval = setInterval(() => setTime(Date.now()), 5000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <Spin spinning={!slots}>
     { slots && <SlotsTab slots={slots} /> }
    </Spin>
  )
}
